module.exports = new __parcel__URL__(require('./helpers/bundle-manifest').resolve("lCrYq")).toString();